<template>
  <div>
    <div
      v-if="descriptionTop"
      class="weather-modal__description"
      v-html="descriptionTop"
    ></div>

    <div
      v-if="staticParams.WEATHER_STATIONS_VIEW_ENABLE"
      class="weather-modal__wrapper"
    >
      <!-- <div class="weather-modal__air-quality">
        <div class="weather-modal__text-data">
          <div class="weather-modal__text-data-label">CO</div>
          <div class="weather-modal__text-data-value">
            {{ formatWithUnit(currentWeather?.airCO, 'µg/m³') }}
          </div>
        </div>

        <div class="weather-modal__text-data">
          <div class="weather-modal__text-data-label">NO</div>
          <div class="weather-modal__text-data-value">
            {{ formatWithUnit(currentWeather?.airNO, 'µg/m³') }}
          </div>
        </div>

        <div class="weather-modal__text-data">
          <div class="weather-modal__text-data-label">PM 2.5</div>
          <div class="weather-modal__text-data-value">
            {{ formatWithUnit(currentWeather?.airPM25, 'µg/m³') }}
          </div>
        </div>

        <div class="weather-modal__text-data">
          <div class="weather-modal__text-data-label">PM 10</div>
          <div class="weather-modal__text-data-value">
            {{ formatWithUnit(currentWeather?.airPM10, 'µg/m³') }}
          </div>
        </div>
      </div>
      -->
      <div class="weather-modal__current-weather current-weather">
        <div class="current-weather__icon-row">
          <div class="current-weather__temperature">
            {{ formatWithUnit(currentWeather?.tempAir, 'ºC', 1) }}
          </div>
        </div>
      </div> 

      <div class="weather-modal__weather-details">
        <div class="weather-modal__icon-data">
          <div class="weather-modal__icon-data-icon">
            <i class="icomoon-meteo-humidity"></i>
          </div>
          <div class="weather-modal__icon-data-value">
            {{ formatWithUnit(currentWeather?.humidity, '% RH', 1) }}
          </div>
        </div>

        <div class="weather-modal__icon-data">
          <div class="weather-modal__icon-data-icon">
            <i class="icomoon-meteo-pressure"></i>
          </div>
          <div class="weather-modal__icon-data-value">
            {{ formatWithUnit(currentWeather?.pressure, 'hPa', 1) }}
          </div>
        </div>

        <div class="weather-modal__icon-data">
          <div class="weather-modal__icon-data-icon">
            <i class="icomoon-meteo-heavy-wind"></i>
          </div>
          <div class="weather-modal__icon-data-value">
            {{ formatWithUnit(currentWeather?.windSpeed, 'm/s', 1) }}
          </div>
        </div>

        <div class="weather-modal__icon-data">
          <div v-if="currentWeather && currentWeather.windDeg !== null">
            <div class="weather-modal__icon-data-icon">
                <i
                :class="
                  currentWeather && currentWeather.windDeg !== null
                  ? directionToIconMapper(direction(currentWeather.windDeg))
                  : ''
                  "
              ></i>
            </div>
            <div class="weather-modal__icon-data-value">
              {{
                currentWeather && currentWeather.windDeg !== null
                ? direction(currentWeather.windDeg)
                : ''
              }}
            </div>
          </div>
          <div v-else>--</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  onMounted,
  Ref,
  ref,
} from 'vue';
import { IWeatherStatus } from '@/interfaces/IWeatherStatus';
import useWeatherDataParser from '@/components/composers/useWeatherDataParser';
import store from '@/store';

export default defineComponent({
  name: 'TemplateModalWeatherStation',

  props: {
    templateData: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const noData = '--';
    const currentWeather: Ref<IWeatherStatus | null> = ref(null);
    const descriptionTop = ref('');
    const { staticParams } = store.state.settings;

    // 🔧 formatter
    const formatWithUnit = (
      val: number | null | undefined,
      unit: string,
      decimalPlaces: number = 2
    ) => {
      if (val === null || val === undefined) return noData;

      const factor = 10 ** decimalPlaces;
      const rounded = Math.round(val * factor) / factor;

      return `${rounded} ${unit}`;
    };

    onMounted(() => {
      const { metaData } = props.templateData;
      descriptionTop.value = metaData.description;
      currentWeather.value = metaData.last_status;
    });

    return {
      descriptionTop,
      currentWeather,
      noData,
      staticParams,
      formatWithUnit,
      ...useWeatherDataParser(),
    };
  },
});
</script>

<style lang="scss">
  .weather-modal {
    height: 100%;
    display: flex;
    flex-direction: column;
    color: white;
    font-size: rem(10px);
    font-weight: 900;
    text-shadow: 0px 3px 6px #00000029;

    &__container{
      padding-top: rem(20px);
      width: 100%;
      margin: 0 auto;
      height: 100%;
      overflow-x: auto;
      display: flex;
      flex-direction: column;
    }

    &__air-quality{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding-bottom: rem(28px);
    }

    &__current-weather{
      padding: rem(28px);
    }

    &__weather-details{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      text-align: center;
    }

    &__text-data{
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 25%;
      padding: 0 rem(5px);
      text-align: center;

      &-label{
        font-size: rem(12px);
        font-weight: 700;
      }

      &-value{
        font-size: rem(12px);
      }
    }

    &__icon-data{
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 25%;
      padding: 0 rem(5px);
      text-align: center;

      &-value{
        font-size: rem(12px);
      }

      &-icon{
        font-size: rem(25px);
        height: rem(25px);
        margin-bottom: rem(12px);

        i{
          display: block;
        }
      }
    }

    &__description {
      text-align: center;
    }

    &__wrapper {
      margin-top: rem(20px);
    }

    &__param {
      &-box {
        margin: 0 rem(14px);
        margin-bottom: rem(13px);
      }

      &-name {
         font-weight: 700;
         font-size: rem(12px);
         margin-bottom: rem(6px);
      }

      &-value {
         font-weight: 900;
         font-size: rem(20px);
      }
    }
  }
</style>
